import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AccountComponent } from "./account.component";
import { ChangeEmailComponent } from "./components/change-email/change-email.component";
import { ChangePinComponent } from "./components/change-pin/change-pin.component";
import { EditProfileComponent } from "./components/edit-profile/edit-profile.component";
import { LogInComponent } from "./components/log-in/log-in.component";
import { MyAccountComponent } from "./components/my-account/my-account.component";
import { ProfileComponent } from "./components/profile/profile.component";
import { RegisterComponent } from "./components/register/register.component";
import { AccountResolver } from "./ngrx/account-resolver";

const routes: Routes = [
    {
        path: '', component: AccountComponent, children: [
          {path: '', resolve: {account: AccountResolver}, component: MyAccountComponent},
          {path: 'login', component: LogInComponent},
          {path: 'register', component: RegisterComponent},
          {path: 'profile', component: ProfileComponent},
          {path: 'changeProfile', component: EditProfileComponent},
          {path: 'changePin', component: ChangePinComponent},
          {path: 'changeEmail', component: ChangeEmailComponent},
          { path: 'myaccount', redirectTo: '', pathMatch: 'full'},
        ]
      },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AccountRoutingModule{}